module.exports = __webpack_public_path__ + "img/Finance&Economics.d847a97b.png";